export default __webpack_public_path__ + "static/media/highlight_test_2.cd29bda4.svg";